import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { LearningCenterService } from './learning-center.service';

@Component({
  selector: 'app-learning-center',
  templateUrl: './learning-center.component.html',
  styleUrls: ['./learning-center.component.scss']
})
export class LearningCenterComponent implements OnInit {
  learningCenter: any;

  page = 1;
  pageSize = 12;
  collectionSize: number;
  rows: any[];
  allLearningCenter: [];
  banner = [{ BANNER_PIC: 'assets/learning-centerBanner.png' }];

  constructor(
    private gobalFunctionService: GobalFunctionService,
    private router: Router,
    private learningCenterService: LearningCenterService,
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setSEO('ศูนย์เรียนรู้', 'website', '');
    this.getLearningCenter();
  }

  getLearningCenter() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        if (res.success) {
          // console.log(res.result);
          this.learningCenter = res.result.filter(center => center.VIEW_STATUS === 1);
          // console.log(this.learningCenter);
          this.refresh();
        }
      }
    );

  }

  refresh() {
    this.collectionSize = this.learningCenter.length;
    this.rows = this.learningCenter
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  view(id) {
    this.router.navigate(['learning-center/' + id]);
  }

}
